import React, { useState, useEffect, useCallback } from 'react';

const MESES_NOMES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
const DIAS_SEMANA = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];

const fmtHora  = (dt) => new Date(dt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
const fmtDia   = (dt) => { const d = new Date(dt); return `${DIAS_SEMANA[d.getDay()]}, ${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}`; };
const fmtSync  = (iso) => {
  if (!iso) return null;
  const diff = Math.round((Date.now() - new Date(iso)) / 60000);
  if (diff < 1) return 'agora mesmo';
  if (diff < 60) return `há ${diff} min`;
  if (diff < 1440) return `há ${Math.round(diff/60)}h`;
  return new Date(iso).toLocaleString('pt-BR',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'});
};

const agrupaPorDia = (vagas) => {
  const dias = {};
  for (const v of vagas) {
    const key = fmtDia(v.data_hora);
    if (!dias[key]) dias[key] = [];
    dias[key].push(v);
  }
  return Object.entries(dias);
};

const Spinner = ({ size = 18 }) => (
  <span style={{ display:'inline-block', width:size, height:size, border:`2px solid #e2e8f0`, borderTopColor:'var(--color-primary,#0f5a30)', borderRadius:'50%', animation:'spin 0.8s linear infinite', flexShrink:0 }} />
);

const Badge = ({ ok, label }) => (
  <span style={{ display:'inline-flex', alignItems:'center', gap:4, background: ok ? '#f0fdf4' : '#fefce8', color: ok ? '#166534' : '#854d0e', border:`1px solid ${ok ? '#bbf7d0' : '#fde047'}`, padding:'2px 8px', borderRadius:20, fontSize:'0.72rem', fontWeight:600, whiteSpace:'nowrap' }}>
    {ok ? '✅' : '⏳'} {label}
  </span>
);

const SetupGuide = () => (
  <div style={{ maxWidth:580, margin:'0 auto' }}>
    <div style={{ background:'#fef9c3', border:'1px solid #fde047', borderRadius:14, padding:'16px 20px', marginBottom:16 }}>
      <h3 style={{ margin:'0 0 6px', fontSize:'0.95rem', color:'#854d0e' }}>⚙️ Configuração necessária</h3>
      <p style={{ margin:0, fontSize:'0.82rem', color:'#713f12', lineHeight:1.6 }}>
        Adicione <code style={{background:'#fef08a',padding:'1px 5px',borderRadius:4}}>GOOGLE_CLIENT_SECRET</code> ao <code>.env</code> do servidor e reinicie.
      </p>
    </div>
  </div>
);

// ─── Cartão de mês ────────────────────────────────────────────────────────────
const MesCard = ({ mes, ano, stats, ativo, onSelect, onSync, onLimpar, syncando, limpando }) => {
  const total = parseInt(stats.total || 0);
  const sinc  = parseInt(stats.sincronizadas || 0);
  const pend  = parseInt(stats.pendentes || 0);
  const pct   = total > 0 ? Math.round((sinc / total) * 100) : 0;
  const tudo  = pend === 0 && total > 0;

  return (
    <div
      onClick={onSelect}
      style={{
        border:`2px solid ${ativo ? 'var(--color-primary,#0f5a30)' : '#e2e8f0'}`,
        borderRadius:14, padding:'14px 16px', cursor:'pointer', background: ativo ? '#f0fdf4' : 'white',
        transition:'border-color 0.15s,background 0.15s', minWidth:160
      }}
    >
      <div style={{ fontWeight:700, fontSize:'0.9rem', color: ativo ? 'var(--color-primary,#0f5a30)' : '#1e293b', marginBottom:8 }}>
        📅 {MESES_NOMES[mes-1]} <span style={{fontWeight:400,color:'#94a3b8'}}>{ano}</span>
      </div>
      <div style={{ display:'flex', gap:6, marginBottom:10, flexWrap:'wrap' }}>
        <span style={{fontSize:'0.72rem',color:'#64748b'}}>{total} vagas</span>
        {tudo
          ? <Badge ok label="Tudo sincronizado" />
          : pend > 0 && <Badge ok={false} label={`${pend} pendente${pend>1?'s':''}`} />
        }
      </div>
      {total > 0 && (
        <div style={{ height:4, borderRadius:4, background:'#e2e8f0', marginBottom:10, overflow:'hidden' }}>
          <div style={{ height:'100%', width:`${pct}%`, background: tudo ? '#22c55e' : 'var(--color-primary,#0f5a30)', borderRadius:4, transition:'width 0.4s' }} />
        </div>
      )}
      <div style={{ display:'flex', gap:6 }} onClick={e => e.stopPropagation()}>
        <button
          onClick={onSync}
          disabled={syncando || limpando}
          title="Sincronizar mês"
          style={{ flex:1, padding:'5px 0', borderRadius:8, border:'none', background:'var(--color-primary,#0f5a30)', color:'white', fontWeight:600, fontSize:'0.75rem', cursor: syncando||limpando ? 'not-allowed' : 'pointer', opacity: syncando||limpando ? 0.6 : 1, display:'flex', alignItems:'center', justifyContent:'center', gap:4 }}
        >
          {syncando ? <Spinner size={12} /> : '🔄'} Sync
        </button>
        <button
          onClick={onLimpar}
          disabled={syncando || limpando || total === 0}
          title="Limpar mês do Google Agenda"
          style={{ flex:1, padding:'5px 0', borderRadius:8, border:'1.5px solid #fecaca', background:'white', color:'#dc2626', fontWeight:600, fontSize:'0.75rem', cursor: syncando||limpando||total===0 ? 'not-allowed' : 'pointer', opacity: syncando||limpando||total===0 ? 0.5 : 1, display:'flex', alignItems:'center', justifyContent:'center', gap:4 }}
        >
          {limpando ? <Spinner size={12} /> : '🗑️'} Limpar
        </button>
      </div>
    </div>
  );
};

// ─── Linha de vaga ────────────────────────────────────────────────────────────
const VagaRow = ({ vaga }) => (
  <div style={{ display:'flex', alignItems:'center', gap:10, padding:'6px 10px', borderRadius:8, background: vaga.google_event_id ? '#f0fdf4' : '#fefce8', marginBottom:4 }}>
    <span style={{ fontSize:'0.8rem', fontWeight:700, color:'#475569', minWidth:42 }}>{fmtHora(vaga.data_hora)}</span>
    <span style={{ fontSize:'0.8rem', color:'#1e293b', flex:1 }}>
      {vaga.trancada && <span style={{marginRight:4}}>🔒</span>}
      {vaga.descricao || '—'}
    </span>
    <span style={{ fontSize:'0.72rem', color:'#94a3b8' }}>{vaga.agendamentos || 0}{vaga.capacidade ? `/${vaga.capacidade}` : ''}</span>
    {vaga.google_event_id
      ? <span style={{fontSize:'0.72rem',color:'#166534',fontWeight:600}}>✅</span>
      : <span style={{fontSize:'0.72rem',color:'#854d0e',fontWeight:600}}>⏳</span>
    }
  </div>
);

// ─── Detalhe do mês expandido ─────────────────────────────────────────────────
const MesDetalhe = ({ vagas, carregando }) => {
  const [diasAbertos, setDiasAbertos] = useState({});

  if (carregando) return (
    <div style={{ display:'flex', justifyContent:'center', padding:32 }}><Spinner size={28} /></div>
  );
  if (!vagas || vagas.length === 0) return (
    <div style={{ textAlign:'center', color:'#94a3b8', padding:24, fontSize:'0.85rem' }}>Nenhuma vaga publicada neste mês.</div>
  );

  const dias = agrupaPorDia(vagas);

  const toggleDia = (key) => setDiasAbertos(p => ({ ...p, [key]: !p[key] }));

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
      {dias.map(([dia, vagasDia]) => {
        const sinc  = vagasDia.filter(v => v.google_event_id).length;
        const aberto = diasAbertos[dia] !== false; // aberto por padrão
        return (
          <div key={dia} style={{ border:'1px solid #e2e8f0', borderRadius:10, overflow:'hidden' }}>
            <div
              onClick={() => toggleDia(dia)}
              style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 12px', background:'#f8fafc', cursor:'pointer', userSelect:'none' }}
            >
              <span style={{ fontSize:'0.85rem', fontWeight:700, color:'#1e293b', flex:1 }}>{dia}</span>
              <span style={{ fontSize:'0.75rem', color:'#64748b' }}>{vagasDia.length} vagas</span>
              <Badge ok={sinc === vagasDia.length} label={`${sinc}/${vagasDia.length} sync`} />
              <span style={{ fontSize:'0.7rem', color:'#94a3b8' }}>{aberto ? '▲' : '▼'}</span>
            </div>
            {aberto && (
              <div style={{ padding:'8px 10px' }}>
                {vagasDia.map(v => <VagaRow key={v.id} vaga={v} />)}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

// ─── Componente principal ─────────────────────────────────────────────────────
export const GerenciadorAgendaGoogle = ({ createApi, isMobile }) => {
  const [status,       setStatus]       = useState(null);
  const [meses,        setMeses]        = useState([]);
  const [mesSel,       setMesSel]       = useState(null);   // { ano, mes }
  const [vagasMes,     setVagasMes]     = useState([]);
  const [carregando,   setCarregando]   = useState(true);
  const [carregandoMes,setCarregandoMes]= useState(false);
  const [ops,          setOps]          = useState({});     // { 'ANO-MES': 'sync'|'limpar' }
  const [toast,        setToast]        = useState(null);

  const showToast = (type, msg) => { setToast({ type, msg }); setTimeout(() => setToast(null), 5000); };

  const loadStatus = useCallback(async () => {
    try {
      const api = createApi();
      const [stRes, mesRes] = await Promise.all([
        api.get('/admin/gcal/status'),
        api.get('/admin/gcal/meses').catch(() => ({ data: { meses: [] } }))
      ]);
      setStatus(stRes.data);
      const mesArr = mesRes.data.meses || [];
      setMeses(mesArr);
      if (!mesSel && mesArr.length > 0) {
        const now = new Date();
        const atual = mesArr.find(m => m.ano === now.getFullYear() && m.mes === (now.getMonth()+1)) || mesArr[0];
        setMesSel({ ano: atual.ano, mes: atual.mes });
      }
    } catch (err) {
      setStatus({ configured: false, connected: false });
    } finally {
      setCarregando(false);
    }
  }, [createApi]); // eslint-disable-line

  useEffect(() => { loadStatus(); }, [loadStatus]);

  const loadVagasMes = useCallback(async (ano, mes) => {
    setCarregandoMes(true);
    try {
      const api = createApi();
      const res = await api.get('/admin/gcal/eventos-mes', { params: { ano, mes } });
      setVagasMes(res.data.vagas || []);
    } catch { setVagasMes([]); }
    finally { setCarregandoMes(false); }
  }, [createApi]);

  useEffect(() => {
    if (mesSel) loadVagasMes(mesSel.ano, mesSel.mes);
  }, [mesSel, loadVagasMes]);

  const handleConnect = async () => {
    try {
      const api = createApi();
      const res = await api.get('/admin/gcal/auth-url');
      const popup = window.open(res.data.url, 'gcal_auth', 'width=500,height=650,left=200,top=100');
      const handler = async (e) => {
        if (e.data?.type === 'gcal_callback') {
          window.removeEventListener('message', handler);
          popup?.close();
          if (e.data.success) { showToast('success', '✅ Google Agenda conectado!'); await loadStatus(); }
          else showToast('error', '❌ Falha na autorização.');
        }
      };
      window.addEventListener('message', handler);
      const poll = setInterval(async () => { if (popup?.closed) { clearInterval(poll); window.removeEventListener('message', handler); await loadStatus(); } }, 1000);
    } catch (err) { showToast('error', '❌ ' + (err.response?.data?.error || err.message)); }
  };

  const handleDisconnect = async () => {
    if (!window.confirm('Deseja desconectar o Google Agenda?')) return;
    try {
      await createApi().delete('/admin/gcal/disconnect');
      showToast('success', 'Google Agenda desconectado.');
      await loadStatus();
    } catch { showToast('error', '❌ Erro ao desconectar.'); }
  };

  const opKey = (ano, mes) => `${ano}-${mes}`;

  const handleSync = async (ano, mes) => {
    const key = opKey(ano, mes);
    setOps(p => ({ ...p, [key]: 'sync' }));
    try {
      const res = await createApi().post('/admin/gcal/sync', { ano, mes }, { timeout: 120000 });
      const { stats } = res.data;
      showToast('success', `✅ ${MESES_NOMES[mes-1]}: ${stats.created} criados, ${stats.updated} atualizados${stats.errors>0 ? `, ${stats.errors} erros`:''}`)
      await Promise.all([loadStatus(), loadVagasMes(ano, mes)]);
    } catch (err) { showToast('error', '❌ ' + (err.response?.data?.error || 'Erro na sincronização')); }
    finally { setOps(p => { const n={...p}; delete n[key]; return n; }); }
  };

  const handleLimpar = async (ano, mes) => {
    const nome = `${MESES_NOMES[mes-1]} de ${ano}`;
    if (!window.confirm(`Remove TODOS os eventos de ${nome} do Google Agenda.\n\nAs vagas do sistema não são excluídas. Continuar?`)) return;
    const key = opKey(ano, mes);
    setOps(p => ({ ...p, [key]: 'limpar' }));
    try {
      const res = await createApi().delete('/admin/gcal/limpar-mes', { params: { ano, mes }, timeout: 120000 });
      const { stats } = res.data;
      showToast('success', `🗑️ ${nome}: ${stats.deleted} evento(s) removido(s)${stats.errors>0 ? `, ${stats.errors} erros`:''}`);
      await Promise.all([loadStatus(), loadVagasMes(ano, mes)]);
    } catch (err) { showToast('error', '❌ ' + (err.response?.data?.error || 'Erro ao limpar')); }
    finally { setOps(p => { const n={...p}; delete n[key]; return n; }); }
  };

  if (carregando) return (
    <div style={{ display:'flex', justifyContent:'center', padding:'4rem' }}><Spinner size={32} /></div>
  );

  return (
    <div style={{ fontFamily:"'Inter',sans-serif", color:'#1e293b' }}>
      <style>{`@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}`}</style>

      {/* Toast */}
      {toast && (
        <div style={{ position:'fixed', top:20, right:20, zIndex:9999, background: toast.type==='success' ? '#f0fdf4' : '#fef2f2', border:`1px solid ${toast.type==='success'?'#bbf7d0':'#fecaca'}`, color: toast.type==='success'?'#166534':'#991b1b', padding:'12px 20px', borderRadius:12, fontWeight:600, boxShadow:'0 8px 24px rgba(0,0,0,0.1)', fontSize:'0.875rem', maxWidth:360 }}>
          {toast.msg}
        </div>
      )}

      {/* Header */}
      <div style={{ padding: isMobile ? '14px 16px' : '20px 28px', borderBottom:'1px solid #f1f5f9', background:'white', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:10 }}>
        <div>
          <h2 style={{ margin:0, fontSize: isMobile?'1rem':'1.2rem', fontWeight:700 }}>📅 Agenda Google</h2>
          <p style={{ margin:'3px 0 0', fontSize:'0.78rem', color:'#64748b' }}>
            {status?.connected ? `Conectado: ${status.email}` : 'Não conectado'}
            {status?.lastSync && <span style={{marginLeft:8}}>· Sync {fmtSync(status.lastSync)}</span>}
          </p>
        </div>
        {status?.connected && (
          <button onClick={handleDisconnect} style={{ padding:'7px 14px', borderRadius:8, border:'1.5px solid #fecaca', background:'white', color:'#dc2626', fontWeight:600, fontSize:'0.78rem', cursor:'pointer' }}>
            Desconectar
          </button>
        )}
      </div>

      <div style={{ padding: isMobile ? '14px 16px' : '20px 28px' }}>

        {/* Setup */}
        {!status?.configured && <SetupGuide />}

        {/* Não conectado */}
        {status?.configured && !status?.connected && (
          <div style={{ maxWidth:440, margin:'0 auto', textAlign:'center', padding:'40px 20px' }}>
            <div style={{ fontSize:'3.5rem', marginBottom:12 }}>📅</div>
            <h3 style={{ margin:'0 0 6px', fontSize:'1.1rem' }}>Google Agenda não conectado</h3>
            <p style={{ color:'#64748b', fontSize:'0.85rem', marginBottom:20, lineHeight:1.6 }}>
              Conecte a conta <strong>allmapilates@gmail.com</strong> para sincronizar as vagas com o Google Agenda.
            </p>
            <button onClick={handleConnect} style={{ padding:'11px 26px', borderRadius:12, border:'none', background:'var(--color-primary,#0f5a30)', color:'white', fontWeight:700, fontSize:'0.9rem', cursor:'pointer', display:'inline-flex', alignItems:'center', gap:10 }}>
              <img src="https://www.google.com/favicon.ico" alt="" width="16" height="16" />
              Conectar Google Agenda
            </button>
          </div>
        )}

        {/* Conectado */}
        {status?.connected && (
          <div style={{ display:'flex', flexDirection:'column', gap:20 }}>

            {/* Cards de meses */}
            {meses.length > 0 ? (
              <div style={{ overflowX:'auto', paddingBottom:4 }}>
                <div style={{ display:'flex', gap:12, minWidth:'max-content' }}>
                  {meses.map(m => {
                    const key = opKey(m.ano, m.mes);
                    return (
                      <MesCard
                        key={key}
                        ano={m.ano} mes={parseInt(m.mes)}
                        stats={m}
                        ativo={mesSel?.ano === m.ano && mesSel?.mes === parseInt(m.mes)}
                        onSelect={() => setMesSel({ ano: m.ano, mes: parseInt(m.mes) })}
                        onSync={() => handleSync(m.ano, parseInt(m.mes))}
                        onLimpar={() => handleLimpar(m.ano, parseInt(m.mes))}
                        syncando={ops[key] === 'sync'}
                        limpando={ops[key] === 'limpar'}
                      />
                    );
                  })}
                </div>
              </div>
            ) : (
              <div style={{ textAlign:'center', color:'#94a3b8', padding:20, fontSize:'0.85rem' }}>
                Nenhuma vaga publicada nos próximos meses.
              </div>
            )}

            {/* Detalhe do mês selecionado */}
            {mesSel && (
              <div style={{ background:'white', border:'1px solid #e2e8f0', borderRadius:14, overflow:'hidden' }}>
                <div style={{ padding:'12px 16px', borderBottom:'1px solid #f1f5f9' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:8 }}>
                    <h3 style={{ margin:0, fontSize:'0.9rem', fontWeight:700 }}>
                      {MESES_NOMES[mesSel.mes-1]} {mesSel.ano}
                      {carregandoMes && <span style={{marginLeft:8}}><Spinner size={14}/></span>}
                    </h3>
                    <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                      <button
                        onClick={() => handleSync(mesSel.ano, mesSel.mes)}
                        disabled={!!ops[opKey(mesSel.ano, mesSel.mes)]}
                        style={{ padding: isMobile ? '6px 10px' : '6px 14px', borderRadius:8, border:'none', background:'var(--color-primary,#0f5a30)', color:'white', fontWeight:600, fontSize: isMobile ? '0.72rem' : '0.78rem', cursor:'pointer', display:'flex', alignItems:'center', gap:5, opacity: ops[opKey(mesSel.ano,mesSel.mes)] ? 0.6 : 1 }}
                      >
                        {ops[opKey(mesSel.ano,mesSel.mes)]==='sync' ? <Spinner size={12}/> : '🔄'} {isMobile ? 'Sync' : 'Sincronizar mês'}
                      </button>
                      <button
                        onClick={() => handleLimpar(mesSel.ano, mesSel.mes)}
                        disabled={!!ops[opKey(mesSel.ano, mesSel.mes)]}
                        style={{ padding: isMobile ? '6px 10px' : '6px 14px', borderRadius:8, border:'1.5px solid #fecaca', background:'white', color:'#dc2626', fontWeight:600, fontSize: isMobile ? '0.72rem' : '0.78rem', cursor:'pointer', display:'flex', alignItems:'center', gap:5, opacity: ops[opKey(mesSel.ano,mesSel.mes)] ? 0.5 : 1 }}
                      >
                        {ops[opKey(mesSel.ano,mesSel.mes)]==='limpar' ? <Spinner size={12}/> : '🗑️'} {isMobile ? 'Limpar' : 'Limpar mês'}
                      </button>
                    </div>
                  </div>
                </div>
                <div style={{ padding:'12px 14px' }}>
                  <MesDetalhe vagas={vagasMes} carregando={carregandoMes} />
                </div>
              </div>
            )}

          </div>
        )}
      </div>
    </div>
  );
};
